import { render } from "./ServiceMeta.vue?vue&type=template&id=163f77cb&ts=true"
import script from "./ServiceMeta.vue?vue&type=script&lang=ts"
export * from "./ServiceMeta.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__